import { Environment } from '@cobliteam/react-environments';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { getAuthHeaders } from '../account/session/AuthToken';
import { SessionManager } from '../account/session/SessionManager';
import { getOpenTelemetryBaggageHttpHeaders } from '../openTelemetryBaggage';
import { ssePool } from './SSEPool';
import type { Configuration, EventSourceOptions } from './Types';

const env = Environment.getInstance().getEnvironment();

export class EventSourceRequester {
  private baseUrl: string;

  private useEventSourceLibrary: boolean;

  private sessionManager: SessionManager;

  constructor(
    configuration: Configuration & { useEventSourceLibrary: boolean },
    sessionManager: SessionManager = new SessionManager({
      host: env.herbieApiHost,
    })
  ) {
    this.baseUrl = configuration.host;
    this.useEventSourceLibrary = configuration.useEventSourceLibrary;
    this.sessionManager = sessionManager;
  }

  private TEN_MINUTES = 60000 * 10;

  public subscribe = (options: EventSourceOptions): Promise<EventSource | EventSourcePolyfill> => {
    const fullUrl = this.baseUrl + options.url;

    return this.sessionManager.maybeRenewAccessToken().then(() => {
      return ssePool.getOrCreate(fullUrl, () => {
        if (this.useEventSourceLibrary) {
          return Promise.resolve(
            new EventSourcePolyfill(fullUrl, {
              headers: {
                ...getAuthHeaders(),
                ...getOpenTelemetryBaggageHttpHeaders(),
              },
              heartbeatTimeout: this.TEN_MINUTES,
            })
          );
        }

        return Promise.resolve(
          new EventSource(fullUrl, {
            withCredentials: true,
          })
        );
      });
    });
  };

  public unsubscribe = (url: string) => {
    const fullUrl = this.baseUrl + url;
    ssePool.release(fullUrl);
  };

  public static unsubscribe = (eventSource: EventSource | EventSourcePolyfill) => eventSource.close();
}

export default EventSourceRequester;
